import TweenMax from 'gsap/TweenMax';

export default function Swim(container, canvas, duration, beforeAnimation) {
  const {
    height: containerHeight,
    bottom: containerBottom,
    left: containerLeft,
    width: containerWidth,
  } = container.getBoundingClientRect();

  const {
    top: canvasTop,
    height: canvasHeight,
    left: canvasLeft,
    width: canvasWidth,
  } = canvas.getBoundingClientRect();

  const initialX = canvasLeft - containerLeft;
  const initialY =
    canvasTop - containerBottom + ((40 / 100) * canvasHeight - containerHeight);

  beforeAnimation(initialX, initialY);

  TweenMax.to(container, 0.25, {
    opacity: 1,
    onComplete() {
      TweenMax.to(container, duration - 0.25, {
        x: initialX + canvasWidth - containerWidth,
      });
    },
  });
}
